import React, { useState, useImperativeHandle, forwardRef } from 'react'
import ReactDOM from 'react-dom'
import Api from '../../../../../_helpers/Api'
import { trans } from '../../../../../_providers/Translation'
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"

import loader from '../../../../../assets/img/loader.svg'

function AddSanction(props, ref) {

    const initialData = {
        amount: '',
        comment: '',
    }

    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
        loading: false,
        reservationId: null,
        data: initialData,
    })

    const [validations, setValidations] = useState(null)

    useImperativeHandle(ref, () => ({
        open: (reservationId) => {
            setPopup(prev => ({
                ...prev,
                overlay: true,
                reservationId,
                data: initialData,
            }))
            setTimeout(() => setPopup(prev => ({ ...prev, modal: true })), 50)
        },
        close: () => handleHide(),
    }))

    const handleHide = e => {
        if (e) e.preventDefault()

        setPopup(prev => ({ ...prev, modal: false, loading: false }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: false,
                reservationId: null,
                data: initialData,
            }))
        }, 50)
    }

    const handleInputChange = e => {
        let name = e.target.name
        let val = e.target.value

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }
        }))
    }

    const handleSave = e => {
        e.preventDefault()

        setPopup(prev => ({ ...prev, loading: true }))
        setValidations(null)

        let data = new FormData(e.target)
        data.append('reservation_id', popup.reservationId)

        Api.post('reservations/sanctions/add', data)
            .then(res => {
                if (props.callback) props.callback(res.data)
                handleHide()
            })
            .catch(error => {
                setPopup(prev => ({ ...prev, loading: false }))

                let _err = error.response

                if (_err && _err.status && _err.status == 422) {
                    for (let [input, err] of Object.entries(_err.data.errors)) {
                        setValidations(prevState => {
                            return { ...prevState, [input]: true }
                        })
                    }
                }
            })
    }

    return ReactDOM.createPortal(
        <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
            <form className={`${popup.modal ? 'show' : ''} popup-primary medium`} onSubmit={handleSave}>
                <div className='head-new'>
                    <img src={popupDefaultHeadImage} alt="icon" />
                    <div className='texts'>
                        <h2 style={{ marginBottom: 0 }}>{trans('headings.addSanction')}</h2>
                    </div>
                    <span className='close' onClick={handleHide}>

                    </span>
                </div>

                <div className="row" style={{ padding: '0 10px 0 0' }}>
                    <div className="col">

                        <input type="hidden" name="reservation_id" value={popup.reservationId || ''} readOnly />

                        <div className="row">
                            <div className="col">
                                <label>
                                    {trans('labels.price')}
                                </label>
                                <input
                                    type="number"
                                    name="amount"
                                    min="0"
                                    step="0.01"
                                    value={popup.data.amount}
                                    className={validations && validations.amount ? 'validate' : ''}
                                    onChange={handleInputChange}
                                    autoFocus
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <label>
                                    {trans('labels.comment')}
                                </label>
                                <textarea
                                    name="comment"
                                    value={popup.data.comment}
                                    className={validations && validations.comment ? 'validate' : ''}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>

                    </div>
                </div>

                <div className="footer align-right">
                    {popup.loading ?
                        <img src={loader} alt="loading" />
                        :
                        <>
                            <button className="button" onClick={handleHide}>
                                {trans('buttons.cancel')}
                            </button>
                            <button className="button button-primary" type="submit">
                                {trans('buttons.save')}
                            </button>
                        </>
                    }
                </div>
            </form>
        </div>,
        document.body
    )
}

export default forwardRef(AddSanction)
